// Helpers pour l'application Biz360

// Normalise le type d'activité pour les comparaisons
const isVenteActivite = (typeActivite) => {
  const t = (typeActivite || "").toLowerCase();
  return t === "vente de marchandises" || t === "artisanale";
};

const isLiberaleActivite = (typeActivite, activite) => {
  const t = (typeActivite || "").toLowerCase();
  const a = (activite || "").toLowerCase();
  return t === "liberale" || t === "libérale" || a === "libérale" || a === "libérale réglementée";
};

export const getCreationDuration = (dateStr) => {
  if (!dateStr) return null;
  const creation = new Date(dateStr);
  const now = new Date();
  const diffMonths = (now.getFullYear() - creation.getFullYear()) * 12 + (now.getMonth() - creation.getMonth());
  if (diffMonths < 12) return `${diffMonths} mois de création ! 🎉`;
  const years = Math.floor(diffMonths / 12);
  return `${years} ${years > 1 ? 'ans' : 'an'} de création ! 🎉`;
};

export const getAcreEndDate = (dateCreation) => {
  if (!dateCreation) return null;
  const creation = new Date(dateCreation);
  const acreEnd = new Date(creation);
  acreEnd.setMonth(acreEnd.getMonth() + 12);
  return acreEnd.toLocaleDateString('fr-FR');
};

export const getVLRate = (typeActivite, activite) => {
  if (isVenteActivite(typeActivite)) return { rate: 0.01, display: "1%" };
  if (isLiberaleActivite(typeActivite, activite)) return { rate: 0.022, display: "2,2%" };
  return { rate: 0.017, display: "1,7%" };
};

export const getTrimestreEmoji = (trimestres) => {
  const emojis = ["🛠️", "🌱", "⚡️", "👑", "💎"];
  return emojis[trimestres] || "🛠️";
};

export const getBeneficeType = (typeActivite) => {
  return isVenteActivite(typeActivite) ? "BIC" : "BNC";
};

export const getAbattement = (typeActivite, activite) => {
  if (isVenteActivite(typeActivite)) return "71%";
  if (isLiberaleActivite(typeActivite, activite)) return "34%";
  return "50%";
};

export const getPlafond = (typeActivite) => {
  return isVenteActivite(typeActivite) ? 188700 : 77700;
};

export const getSeuilTVA = (typeActivite) => {
  // Seuils TVA 2025-2026
  return isVenteActivite(typeActivite) 
    ? { base: 85000, majore: 93500 } 
    : { base: 37500, majore: 41250 };
};
